import React from 'react';
import './styles.scss';

const ReviewCard = ({ review }) => (
  <div className="review-card">
    <div className="review-card__author-info">
      <img className="review-card__author-avatar" src={review.author.avatarImageUrl} alt="avatar" />
      <div>
        <b title={review.author.fullName}>{review.author.fullName}</b>
        <p className="review-card__author-location-text">{review.author.location}</p>
      </div>
    </div>
    <div className="review-card__comment-wrapper">
      <p>{review.comment}</p>
    </div>
  </div>
);

export default ReviewCard;
